<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        @click="onOpen"
        v-on="on"
      >
        Configure KeyPay
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Configure KeyPay</v-card-title>

      <v-card-text>
        <v-col>
          <v-row>
            <v-text-field label="Api Key" v-model="credentials.keypayApiKey"></v-text-field>
          </v-row>
          <v-row>
            <v-text-field label="Business ID" v-model="credentials.keypayBusinessId"></v-text-field>
          </v-row>
          <v-row align-center>
            <v-select
              label="Parent Location ID"
              :items="locations"
              v-model="credentials.parentLocationId"
              :loading="loadingLocations"
              align-center
            />
            <v-btn color="success" @click="getLocations" icon class="mt-4">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-card-text>

      <v-divider></v-divider>

        <v-card-actions>
          <v-container
            v-if="saving"
          >
          Saving credentials...
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>

          </v-container>
          <v-spacer></v-spacer>
          <v-btn color="normal" text @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary"
            text
            @click="onSaveCredentials"
            :disabled="saving"
          > Save </v-btn>
        </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
const axios = require('axios');

export default {
  data() {
    return {
      dialog: false,
      showPassword: false,
      locations: [],
      loadingLocations: false,
    };
  },
  props: {
    credentials: Object,
    saving: Boolean,
  },
  created() {
    if (this.credentials.keypayApiKey && this.credentials.keypayBusinessId) {
      this.getLocations();
    }
  },
  methods: {
    onSaveCredentials() {
      this.$emit('saveCredentials', this.credentials);
    },
    onOpen() {
      this.$emit('updateBusiness');
    },
    async getLocations() {
      try {
        this.loadingLocations = true;
        const { data } = await axios.get(
          `https://api.yourpayroll.com.au/api/v2/business/${this.credentials.keypayBusinessId}/location`,
          { auth: { username: this.credentials.keypayApiKey } },
        );
        this.locations = data.map((loc) => ({
          text: loc.name,
          value: loc.id,
        }));
        this.loadingLocations = false;
      } catch (err) {
        console.log(`Couldn't get Keypay locations: ${err.message}`);
        // TODO: Display error (on parent?)
      }
    },
  },
};
</script>

<style scoped>

</style>
